const STRICT_REGEX = /[.-]/g;
const NON_STRICT_REGEX = /[^\d]/g;
const REJECT_CPF_LIST = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];
export function digitsVerifier(numbers: string): number {
  const numberList = numbers.split('').map((number) => parseInt(number, 10));
  const modulo = numberList.length + 1;
  const multiplied = numberList.map((number, index) => number * (modulo - index));
  const mod = multiplied.reduce((buffer, number) => buffer + number) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
export function isValidCPF(cpf: string, isStrict: boolean = false): boolean {
  const stripped = strip(cpf, isStrict);

  // CPF must be defined
  if (!stripped) {
    return false;
  }

  // CPF must have 11 chars
  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  let numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
export function strip(cpf: string, isStrict: boolean = false): string {
  const regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
